import React, { Component } from 'react';
import { ApolloProvider } from 'react-apollo';
import UQClient from './client';

export default class FMCProvider extends Component {
  render() {
    console.log('env', process.env.REACT_APP_GRAPHQL_URL);
    console.log('env. var', process.env.REACT_APP_OIDC_AUTHORIZE_URL);
    const { children } = this.props;
    return (
      <ApolloProvider client={UQClient}>
        {children}
      </ApolloProvider>);
  }
}